import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { Image } from "../../foundations/Image/Image";
import { buildImageSizes } from "../../foundations/Image/utils/buildImageSizes";
import { buildImageSrcSet } from "../../foundations/Image/utils/buildImageSrcSet";
// TODO: replace with ribbons ProductCard import when available
import { CarouselProductCard } from "../Cards/CarouselProductCard/components/CarouselProductCard";
import * as styles from "./PartnerProfile.styles";
export var PartnerProfile = function PartnerProfile(_ref) {
  var _images$;
  var copy = _ref.copy,
    cta = _ref.cta,
    currency = _ref.currency,
    heading = _ref.heading,
    imageHeight = _ref.imageHeight,
    imageWidth = _ref.imageWidth,
    images = _ref.images,
    lazyImages = _ref.lazyImages,
    onPartnerClick = _ref.onPartnerClick,
    onProductClick = _ref.onProductClick,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible,
    products = _ref.products,
    url = _ref.url;
  var _useVisibilityObserve = useVisibilityObserver(function () {
      return onVisible();
    }),
    productsRef = _useVisibilityObserve.observedElementRef;
  var handleClick = function handleClick(e) {
    onPartnerClick === null || onPartnerClick === void 0 || onPartnerClick(e);
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.partner
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.partnerImageContainer
  }, /*#__PURE__*/React.createElement(_StyledImage, {
    height: imageHeight,
    loading: lazyImages ? 'lazy' : 'eager',
    sizes: buildImageSizes({
      XXS: '75vw',
      M: '33vw',
      L: '25vw',
      XL: '330px'
    }),
    src: (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.src,
    srcSet: buildImageSrcSet(images.map(function (_ref2) {
      var src = _ref2.src,
        width = _ref2.width;
      return {
        src,
        width,
        unit: 'w'
      };
    })),
    width: imageWidth,
    $_css3: styles.partnerImage
  })), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css4: styles.partnerCopyContainer
  }, /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css5: styles.partnerCopyContent
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css6: styles.partnerHeading
  }, heading), /*#__PURE__*/React.createElement(_StyledP, {
    $_css7: styles.partnerCopy
  }, copy), /*#__PURE__*/React.createElement(_StyledA, {
    href: url,
    onClick: handleClick,
    $_css8: styles.partnerCta
  }, cta))), /*#__PURE__*/React.createElement(_StyledDiv5, {
    ref: productsRef,
    $_css9: styles.productsContainer
  }, products.length > 0 && products.map(function (product, productIndex) {
    return /*#__PURE__*/React.createElement(_StyledDiv6, {
      key: product.title,
      $_css10: styles.product
    }, /*#__PURE__*/React.createElement(CarouselProductCard, _extends({}, product, {
      currency: currency,
      imageLoading: lazyImages ? 'lazy' : 'eager',
      onLinkClick: function onLinkClick(e) {
        return onProductClick === null || onProductClick === void 0 ? void 0 : onProductClick(e, {
          productIndex
        });
      },
      size: "auto"
    })));
  })));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledImage = _styled3(Image)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv3 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledDiv4 = _styled5("div")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledH = _styled6("h3")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledP = _styled7("p")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledA = _styled8("a")(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css8;
});
var _StyledDiv5 = _styled9("div")(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css9;
});
var _StyledDiv6 = /*#__PURE__*/_styled10("div").withConfig({
  displayName: "PartnerProfile___StyledDiv6",
  componentId: "sc-1f7cswf-0"
})(["", ""], function (p) {
  return p.$_css10;
});